import { FormLabelProps } from '@/components/elements/FormLabel'

export const corporationLabels: {
  company: FormLabelProps
  fullName: FormLabelProps
  lastName: FormLabelProps
  firstName: FormLabelProps
  email: FormLabelProps
  tel: FormLabelProps
  title: FormLabelProps
  detail: FormLabelProps
} = {
  company: {
    text: '会社名',
    isRequired: false,
    inputId: 'company',
  },
  fullName: {
    text: 'ご氏名',
    isRequired: true,
    inputId: 'lastName',
  },
  lastName: {
    text: '姓',
    isRequired: 'none',
    inputId: 'lastName',
  },
  firstName: {
    text: '名',
    isRequired: 'none',
    inputId: 'firstName',
  },
  email: {
    text: 'Eメールアドレス',
    isRequired: true,
    inputId: 'email',
  },
  tel: {
    text: '電話番号',
    isRequired: false,
    inputId: 'tel',
  },
  title: {
    text: 'お問い合せ件名',
    isRequired: false,
    inputId: 'title',
  },

  detail: {
    text: 'お問い合せの詳細をご記入ください',
    isRequired: true,
    inputId: 'detail',
  },
}

export const formData = {
  company: '株式会社 TRIAL',
  lastName: 'トライアル',
  firstName: '太郎',
  email: 'XXX@XXX.ne.jp',
  tel: '009-0000-0000',
  title: '件名が入りますダミー',
  detail:
    'ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。',
}
